import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from './tenant.service';

/** The password reset pages only exist on a tenant login (/<tenant>/...) whose portal has password reset switched on. */
export const passwordResetGuard: CanActivateFn = async (route) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);
  const routePrefix = route.paramMap.get('forsyning');
  if (routePrefix && await tenantService.isPasswordResetEnabled(routePrefix)) {
    return true;
  }

  return router.createUrlTree(routePrefix ? [routePrefix, 'login'] : ['login']);
};
